export const MAP_STOP_INFO_WINDOW_CONFIG: google.maps.InfoWindowOptions = {
  minWidth: 250,
  maxWidth: 450,
  ariaLabel: 'STOP_POPUP',
};

export const MAP_POINT_INFO_WINDOW_CONFIG: google.maps.InfoWindowOptions = {
  minWidth: 250,
  maxWidth: 450,
  ariaLabel: 'POINT_POPUP',
};
